import imageCompression from "browser-image-compression";

export const DEFAULT_MAX_SELECTED_PHOTOS = 10;
export const EMESSAGE_MAX_SELECTED_PHOTOS = 4;

export async function compressImageFile(
  file: File,
  opts?: { maxSizeMB?: number; maxWidthOrHeight?: number },
): Promise<File> {
  if (!file || typeof file.type !== "string" || !file.type.startsWith("image/")) return file;
  try {
    const compressed = await imageCompression(file, {
      maxSizeMB: opts?.maxSizeMB ?? 1.5,
      maxWidthOrHeight: opts?.maxWidthOrHeight ?? 2048,
      useWebWorker: true,
      initialQuality: 0.9,
    });
    if (compressed instanceof File) return compressed;
    return new File([compressed], file.name, { type: (compressed as any)?.type || file.type });
  } catch {
    return file;
  }
}

export function filterImageFiles(files: readonly File[]): File[] {
  const allowedExts = new Set([".jpg", ".jpeg", ".png", ".heic"]);
  return files.filter((f) => {
    if (!f) return false;
    if (typeof f.type === "string" && f.type.startsWith("image/")) return true;
    const name = typeof f.name === "string" ? f.name.toLowerCase() : "";
    if (!name) return false;
    for (const ext of allowedExts) {
      if (name.endsWith(ext)) return true;
    }
    return false;
  });
}
